<template>
  <div>
    <div style="text-align: left">
      <div class="searchbarcls">
        <el-form :model="searchForm">
          所属部门:<el-input size="small" v-model="searchForm.employeeDepartment" style="width: 200px;"></el-input>
          人员姓名:<el-input size="small" v-model="searchForm.employeeName" style="width: 160px;"></el-input>
          &nbsp;<el-button type="primary" icon="el-icon-search" size="small" @click="loadTableData()">查询</el-button>
        </el-form>
      </div>
      <div style="padding: 2px;">
        <PermissionMethodToolbar :url="url" id="toolbar" @showAddDialog="showAddDialog"></PermissionMethodToolbar>
      </div>
    </div>
    <el-table ref="myElTable" background="true" :data="tableData" :height="clientHeight-otherHeight" @row-click="tableTrClick" border style="width: 100%;">
      <el-table-column type="selection" width="42" />
      <el-table-column type="index" label="序号" fixed="left" width="50">
      </el-table-column>
      <el-table-column prop="employeeDepartment" label="所属部门" width="230">
      </el-table-column>
      <el-table-column prop="employeeName" label="人员姓名" width="130">
        <template slot-scope="scope">
          <el-button type="text" @click="showPermissionDialog(scope.row)">{{ scope.row.employeeName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="电子签字" width="130">
        <template slot-scope="scope">
          <img :src="'/api/imgs/'+scope.row.signImgUUID" style="width: 80px; height: 50px;">
        </template>
      </el-table-column>
      <el-table-column prop="employeeSex" label="性别" width="70">
      </el-table-column>
      <el-table-column prop="employeeJob" label="职位" width="130">
      </el-table-column>
      <el-table-column prop="serviceDate" label="入职日期" width="130">
      </el-table-column>
      <el-table-column prop="employeeTel" label="联系方式" width="130">
      </el-table-column>
      <el-table-column prop="userAccount" label="用户帐号" width="160">
        <template slot-scope="scope">
          <el-button type="primary" plain size="mini" @click="showUpdateEmpAccountDialog(scope.row)" v-if="scope.row.userAccount!=null">{{ scope.row.userAccount }}</el-button>
          <el-button type="success" size="mini" plain v-if="scope.row.userAccount==null" @click="showAddEmpAccountDialog(scope.row)">创建帐号</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="roleNames" label="拥有角色">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="280">
        <template slot-scope="scope">
          <PermissionMethodRow :url="url" id="rowtoolbar" @showUpdateDialog="showUpdateDialog(scope.row)" @deleteEmployee="deleteEmployee(scope.row)"></PermissionMethodRow>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.currPage" :page-sizes="[20, 30, 50]" :page-size="20"
                   layout="total,jumper, prev, pager, next,sizes" :total="searchForm.dataTotal">
    </el-pagination>
    <!--添加div-->
    <el-dialog title="新增人员信息" size="35%" :visible.sync="drawer" :wrapperClosable="false" direction="rtl">
      <AddEmployeeWindow ref="addEmployeeWindow" :closeWindow="closeWindow"></AddEmployeeWindow>
    </el-dialog>
    <!--修改div-->
    <el-dialog title="修改人员信息" size="35%" :visible.sync="udrawer" :wrapperClosable="false" direction="rtl">
      <UPdateEmployeeWindow ref="updateEmployeeWindow" :employeeData="employeeData" :closeWindow="closeWindow"></UPdateEmployeeWindow>
    </el-dialog>
    <!--修改div-->
    <el-dialog title="创建人员帐号" size="35%" :visible.sync="empadddrawer" :wrapperClosable="false" direction="rtl">
      <AddEmpAccountWindow ref="addEmpAccountWindow" :employeeData="employeeData" :closeWindow="closeWindow"></AddEmpAccountWindow>
    </el-dialog>
    <!--修改div-->
    <el-dialog title="修改人员帐号" size="35%" :visible.sync="empupdatedrawer" :wrapperClosable="false" direction="rtl">
      <UPdateUserWindow ref="updateEmpAccountWindow" :userData="employeeData" :closeWindow="closeWindow"></UPdateUserWindow>
    </el-dialog>
    <!--权限配置div-->
    <el-dialog title="人员权限配置" size="80%" :visible.sync="permissiondrawer" :wrapperClosable="false" direction="rtl">
      <EmployeePermissionWindow ref="employeePermissionWindow" :employeeData="employeeData" :closeWindow="closeWindow"></EmployeePermissionWindow>
    </el-dialog>
  </div>
</template>
<script>
import AddEmployeeWindow from '@/views/business/employee/AddEmployeeWindow.vue';
import UPdateEmployeeWindow from '@/views/business/employee/UpdateEmployeeWindow.vue';
import AddEmpAccountWindow from '@/views/business/employee/AddEmpAccountWindow.vue';
import UPdateUserWindow from '@/views/system/user/UpdateUserWindow.vue';
import EmployeePermissionWindow from '@/views/business/employee/EmployeePermissionWindow.vue';
import { appjs } from "@/utiljs/apputil";
import { queryPermissionsByEmployee, batchSaveOrUpdateEmployeeSignPermission } from '@/api/contract/contract';
export default {
  components: {
    AddEmployeeWindow,
    UPdateEmployeeWindow,
    AddEmpAccountWindow,
    UPdateUserWindow,
    EmployeePermissionWindow
  },
  props: {
    clientHeight: {
      type: Number
    },
    url: {
      type: String
    }
  },
  data () {
    return {
      otherHeight: 210,
      drawer: false,
      empadddrawer: false,
      empupdatedrawer: false,
      udrawer: false,
      permissiondrawer: false,
      employeeData: {},
      searchForm: {
        dataTotal: 0,
        pageSize: 20,
        currPage: 1,
        employeeDepartment: '',
        employeeName: '',
        userAccount: ''
      },
      tableData: []
    }
  },
  created () {
    this.loadTableData(1);
  },
  methods: {
    //提供给子组件调用的方法
    closeWindow (msg) {
      this.drawer = false;
      this.udrawer = false;
      this.empadddrawer = false;
      this.empupdatedrawer = false;
      this.permissiondrawer = false;
      if (msg) {
        this.loadTableData(1);
        appjs.showSuccessMsg(msg, 2000, 50);
      }
    },
    loadTableData () {
      let load = appjs.loading();
      let _self = this;
      let params = this.searchForm;
      appjs.httpRequest('employee/queryEmployee', params).then(
        (data) => {
          if (data.retCode && data.retCode != "ok") {
            appjs.showErrorMsg(data.retMsg)
          } else {
            _self.searchForm.dataTotal = data.totalRowNum;
            _self.tableData = data.dataList;
            this.$refs.myElTable.bodyWrapper.scrollTop = 0;
          }
          appjs.unloading(load);
        }
      ).catch(
        (errmsg) => {
          appjs.showErrorMsg(errmsg)
          appjs.unloading(load);
        });
    },
    deleteEmployee (rowdata) {
      let _self = this;
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        let load = appjs.loading('数据删除中');
        appjs.httpRequest('employee/deleteEmployee', { employeePid: rowdata.employeePid }).then(
          (data) => {
            if (data.retCode && data.retCode != "ok") {
              appjs.unloading(load);
              appjs.showErrorMsg(data.retMsg)
            } else {
              appjs.unloading(load);
              appjs.showSuccessMsg(data.retMsg)
              _self.loadTableData();
            }
          }
        ).catch(
          (errmsg) => {
            appjs.showErrorMsg(errmsg)
            appjs.unloading(load);
          });
      });
    },
    //表格行点击
    tableTrClick (row, column, event) {
      this.$refs.myElTable.clearSelection();
      this.$refs.myElTable.toggleRowSelection(row);
    },
    //每页显示行数改变
    handleSizeChange (val) {
      this.searchForm.pageSize = val;
      this.loadTableData();
    },
    //分页栏
    handleCurrentChange (val) {
      this.searchForm.currPage = val;
      this.loadTableData();
    },
    showAddDialog () {
      this.drawer = true;
      this.$nextTick(() => {
        if (this.$refs['addEmployeeWindow']) {
          this.$refs['addEmployeeWindow'].resertForm();
        }
      });
    },
    showUpdateDialog (data) {
      this.employeeData = JSON.parse(JSON.stringify(data));
      let _self = this;
      _self.udrawer = true;
      this.$nextTick(() => {
        if (_self.$refs['updateEmployeeWindow']) {
          _self.$refs['updateEmployeeWindow'].resertForm();
        }
      });
    },
    showAddEmpAccountDialog (data) {
      this.employeeData = JSON.parse(JSON.stringify(data));
      let _self = this;
      _self.empadddrawer = true;
      this.$nextTick(() => {
        if (_self.$refs['addEmpAccountWindow']) {
          _self.$refs['addEmpAccountWindow'].resertForm();
        }
      });
    },
    showUpdateEmpAccountDialog (data) {
      this.employeeData = JSON.parse(JSON.stringify(data));
      this.employeeData.userName = data.employeeName;
      let _self = this;
      _self.empupdatedrawer = true;
      this.$nextTick(() => {
        if (_self.$refs['updateEmpAccountWindow']) {
          _self.$refs['updateEmpAccountWindow'].resertForm();
        }
      });
    },
    // 显示权限配置弹出层
    showPermissionDialog (data) {
      this.employeeData = JSON.parse(JSON.stringify(data));
      let _self = this;
      _self.permissiondrawer = true;
      this.$nextTick(() => {
        if (_self.$refs['employeePermissionWindow']) {
          _self.$refs['employeePermissionWindow'].resertForm();
        }
      });
    }
  }
}
</script>
